import { render, staticRenderFns } from "./InfoCookieToast.vue?vue&type=template&id=56e7b704&scoped=true"
import script from "./InfoCookieToast.vue?vue&type=script&lang=js"
export * from "./InfoCookieToast.vue?vue&type=script&lang=js"
import style0 from "./InfoCookieToast.vue?vue&type=style&index=0&id=56e7b704&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e7b704",
  null
  
)

export default component.exports